import React, { createContext, useState } from 'react';
import { FileConfig } from './FileConfig';

export const FileContext = createContext();

export const FileProvider = ({ children }) => {
    // Instead of a single FileConfig, store an array of FileConfig instances
    const [fileConfigs, setFileConfigs] = useState([]);
    const [selectIndex, setSelectIndex] = useState(0);

    // Optional helper to add a new FileConfig
    const addFileConfig = (file, url, oldfile) => {
        const newConfig = new FileConfig(file, url, oldfile);
        // console.log('Hii')
        setFileConfigs(prev => [...prev, newConfig]);
    };

    // Optional helper to update a specific FileConfig by index or some unique ID
    const updateFileConfig = (index, updatedConfig) => {
        setFileConfigs(prev => {
            const updated = [...prev];
            console.log(index, 'context-index')
            updated[index] = updatedConfig;
            console.log(updated, 'context-updated')
            return updated;
        });
    };

    // ✅ Delete a FileConfig by its index
    const deleteFileConfig = (indexToRemove) => {
        setFileConfigs(prev => prev.filter((_, index) => index !== indexToRemove));
        setSelectIndex(0);
    };

    return (
        <FileContext.Provider value={{ fileConfigs, setFileConfigs, addFileConfig, updateFileConfig, deleteFileConfig, selectIndex, setSelectIndex }}>
            {children}
        </FileContext.Provider>
    );
};
